export const SERVICE_LINKS = {
  WEBSITE: 'https://bughole.io',
  GITHUB: 'https://github.com/bug4city/lair-lsd',
  AUDIT: 'https://github.com/bug4city/lair-lsd/tree/master/audit',
  /** Socials **/
  MEDIUM: 'https://medium.com/lair-finance',
  DISCORD: 'https://discord.gg/lairfinance',
  TWITTER: 'https://twitter.com/LairFinance',
  TELEGRAM: 'https://t.me/lairfinance',
  /** Docs **/
  DOCS: 'https://lair-finance.gitbook.io/lair-finance',
  REFERRAL: 'https://lair-finance.gitbook.io/lair-finance/farming/acorn-points',
  TERMS: 'https://lair-finance.gitbook.io/lair-finance/legal/terms-of-use',
  PRIVACY: 'https://lair-finance.gitbook.io/lair-finance/legal/privacy-policy',
  REWARD: 'https://lair-finance.gitbook.io/lair-finance/farming/stkaia-rewards-campaign',
  MEDIAKIT: 'https://lair-finance.gitbook.io/lair-finance/general-guides/media-kit',
  /** Apps **/
  LANDING: 'https://lair.fi',
  APP_STAKE: 'https://app.lair.fi',
  APP_RESTAKE: 'https://app.lair.fi/restake',
  APP_UNSTAKE: 'https://app.lair.fi/unstake',
  APP_REWARD: 'https://app.lair.fi/reward',
  APP_FARM: 'https://app.lair.fi/farm',
  APP_EARN: 'https://app.lair.fi/earn',
  APP_AIRDROPS: 'https://app.lair.fi/airdrops',
}
